
import {ø} from "../../util/objects.js";
import * as utc from "../../util/utc.js";
import {resolveTimeCursor} from "../../util/dates.js";
import {scalarProduct} from "../scalarProduct.js";
import * as sources from "../sources.js";
import {tr} from "../../ux/translations.js";
import {newProduct, resolveValidTime} from "../productUtils.js";
import {createUnitDescriptors} from "../../util/units.js";
import {gaiaPath} from "../gaia.js";
import {createSSTPalette} from "../../palette/sst.js";
import {createSSTAPalette} from "../../palette/ssta.js";


let palettes = {};

export function rtgPath(attr, name) {
    const parts = resolveTimeCursor(attr.time_cursor);
    const isNow = attr.time_cursor === "now";
    const dir = isNow ? "current" : utc.print(parts, "{YYYY}/{MM}");
    const timestamp = isNow ? "current" : utc.print(parts, "{YYYY}{MM}{DD}");
    const file = `${timestamp}-${name}-rtg-0.5.epak`;
    return gaiaPath("data/rtgsst", dir, file);
}

function newRTGProduct(attr, timeline) {
    const resolvedTimeCursor = utc.add(resolveTimeCursor(attr.time_cursor), {day: attr.time_cursor === "now" ? -1 : 0});

    const alignment = {day: 1};
    const validTime = resolveValidTime(resolvedTimeCursor, alignment);
    const stepper = step => function() {
        return resolveValidTime(utc.add(this.validTime(), step), alignment);
    };
    return {
        sourceHTML: sources.rtgsst,
        validTime: () => ø(validTime),
        timeline,
        prev2: stepper({day: -5}),
        prev1: stepper({day: -1}),
        next1: stepper({day: +1}),
        next2: stepper({day: +5}),
        navLabels: {
            prev2: `-5 ${tr`days`}`,
            prev1: `-1 ${tr`day`}`,
            next1: `+1 ${tr`day`}`,
            next2: `+5 ${tr`days`}`,
        },
    };
}

export function createRTGSST(attr, timeline) {
    return ø(newProduct(), newRTGProduct(attr, timeline), {
        type: "sea_surface_temp",
        descriptionHTML: {
            name: tr`Sea Surface Temperature`,
            qualifier: "",
        },
        paths: [rtgPath(attr, "sea_surface_temp")],
        builder: file => scalarProduct(file, /Temperature_surface_sparse/, {hasMissing: true}),
        unitDescriptors: createUnitDescriptors({
            "°C": {convert: x => x - 273.15,       precision: 1},
            "°F": {convert: x => x * 9/5 - 459.67, precision: 1},
            "K":  {convert: x => x,                precision: 1},
        }),
        scale: palettes.sst ??= createSSTPalette(),
        alpha: {single: 200, animated: 132},
    });
}

export function createRTGSSTA(attr, timeline) {
    return ø(newProduct(), newRTGProduct(attr, timeline), {
        type: "sea_surface_temp_anomaly",
        descriptionHTML: {
            name: tr`Sea Surface Temperature Anomaly`,
            qualifier: "",
        },
        paths: [rtgPath(attr, "sea_surface_temp_anomaly")],
        builder: file => scalarProduct(file, /Temperature_surface_anomaly_sparse/, {hasMissing: true}),
        unitDescriptors: createUnitDescriptors({
            "°C": {convert: x => x,       precision: 1},
            "°F": {convert: x => x * 9/5, precision: 1},
            "K":  {convert: x => x,       precision: 1},
        }),
        scale: palettes.ssta ??= createSSTAPalette(),
    });
}
